module.exports = __webpack_public_path__ + "img/whatsapp-icon.4d60c74b.png";